// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dual_promo-module--wrapper--1G-UE","inner":"dual_promo-module--inner--itcry","imageLink":"dual_promo-module--image-link--21DBr"};